const toggleAEMSibling = (isSectionShown: boolean) => {
  const calcPensionPot = document.getElementById('calc-pension-pot') as HTMLElement;
  const calcParent = calcPensionPot && calcPensionPot.parentElement as HTMLElement;

  if (calcParent) {
    let element = calcParent;
    const uncles = [] as HTMLElement[];

    while (element.nextElementSibling) {
      element = element.nextElementSibling as HTMLElement;
      uncles.push(element);
    }

    const checkEditMode = calcPensionPot.dataset.wcmmodeEdit === '';

    if (uncles.length > 0 && !checkEditMode) {
      uncles.forEach(uncle => {
        const uncleToHide = uncle;
        uncleToHide.style.display = isSectionShown ? 'block' : 'none';
      });
    }
  }
};

export default toggleAEMSibling;



// WEBPACK FOOTER //
// ./src/utilities/toggleAEM.ts